import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import {
  primaryLabelName,
  secondaryLabelName,
  uniqueIdentifier1Name,
  uniqueIdentifier2Name,
} from "../../utils/helper";

const API = localStorage.getItem("assethost");

export default class AssetView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      asset: null,
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const assetId = urlParams.get("assetId") || this.props.assetId;
    const primaryName = this.props.primaryName;
    const secondaryName = this.props.secondaryName;
    const assetType = this.props.assetType
    const categoryName = this.props.categoryName
    const subCategoryName = this.props.subCategoryName
    const uniqueIdentifier = this.props.uniqueIdentifier;

    if (!assetId) {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
      return;
    }

    this.setState({ assetId, primaryName, secondaryName, assetType, uniqueIdentifier, categoryName, subCategoryName }, () => this.getAssetData(assetId));
  }

  getAssetData(assetId) {
    const token = sessionStorage.getItem("token");
    if (!token) {
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search}`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(`${API}/asset/getbyid/${assetId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          asset: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error?.response?.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search}`;
          return;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to load asset data. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  renderFilePreview(contentType, base64Data, title) {
    if (!contentType || !base64Data) return null;

    if (contentType === "application/pdf") {
      return (
        <iframe
          title={title}
          src={`data:${contentType};base64,${base64Data}`}
          className="w-full h-80 border rounded-lg shadow"
        />
      );
    }

    if (contentType.startsWith("image/")) {
      return (
        <img
          src={`data:${contentType};base64,${base64Data}`}
          alt={title}
          className="w-full rounded-lg shadow object-contain max-h-96"
        />
      );
    }

    return (
      <a
        href={`data:${contentType};base64,${base64Data}`}
        download={title || "file"}
        className="text-blue-600 underline"
      >
        Download {title || "file"}
      </a>
    );
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return (
        <Modal title="Loading Asset Data" footerContent={<></>}>
          <div className="flex justify-center items-center py-10">
            <Spinner />
          </div>
        </Modal>
      );
    }

    if (s.msg && !s.asset) {
      return (
        <Modal title="Asset Information" footerContent={<></>}>
          <div
            className={`alert ${
              s.toastColor === "success" ? "alert-success" : "alert-danger"
            } mx-7`}
          >
            {s.msg}
          </div>
        </Modal>
      );
    }

    const a = s.asset || {};

    return (
      <Modal
        title="Asset Information"
        closeAction={this.props.closeAction}
        footerContent={
          <button
            type="button"
            className="btn btn-success"
            onClick={this.props.closeAction}
          >
            Close
          </button>
        }
      >
        <div className="max-w-5xl mx-auto p-6 space-y-6">
          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-blue-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586l6.414 6.414V19a2 2 0 01-2 2z"
                />
              </svg>
              Asset Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <Info label={primaryLabelName(s.assetType)} value={s.primaryName} />
              <Info label={secondaryLabelName(s.assetType)} value={s.secondaryName} />
              <Info label="Category" value={s.categoryName} />
              <Info label="Sub-Category" value={s.subCategoryName} />
              <Info label={uniqueIdentifier1Name(s.assetType)} value={s.uniqueIdentifier} />
              {a.uniqueIdentifier2 &&
              <Info label={uniqueIdentifier2Name(s.assetType)} value={a.uniqueIdentifier2} />
               }
              <Info label="Year" value={a.year} />
              <Info label="Color" value={a.color} />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h10a2 2 0 012 2v16z"
                />
              </svg>
              Ownership Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <Info label="Type" value={a.ownershipType} />
              <Info label="Details" value={a.ownershipDetails} />
              <Info label="Agreement Start Date" value={a.agreementStartDate} />
              <Info label="Agreement End Date" value={a.agreementEndDate} />
            </div>
            {a.ownershipFileData &&
              this.renderFilePreview(
                a.ownershipFileContentType,
                a.ownershipFileData,
                a.ownershipFileName || "Ownership File"
              )}
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-purple-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 10l4.553 2.276a1 1 0 010 1.448L15 16m-6 0l-4.553-2.276a1 1 0 010-1.448L9 10m6 6V8m-6 8V8"
                />
              </svg>
              Unique Marker
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <Info label="Description" value={a.uniqueMarkerDescription} />
              <Info label="Location" value={a.locationOfMarker} />
            </div>
            {a.uniqueMarkerFileData &&
              this.renderFilePreview(
                a.uniqueMarkerFileContentType,
                a.uniqueMarkerFileData,
                a.uniqueMarkerFileName || "Unique Marker File"
              )}
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-pink-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16l4-4-4-4m16 8l-4-4 4-4M12 20v-8m0-8v8"
                />
              </svg>
              Asset Picture
            </h3>
            {a.assetPictureFileData ? (
              this.renderFilePreview(
                a.assetPictureFileContentType,
                a.assetPictureFileData,
                a.assetPictureFileName || "Asset Picture"
              )
            ) : (
              <div className="text-gray-500 italic">
                No asset image available
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

const Info = ({ label, value }) => (
  <div>
    <span className="font-medium text-gray-600">{label}:</span>{" "}
    <span className="text-gray-800">{value || "N/A"}</span>
  </div>
);
